"use client";
import React, { useEffect, useState } from "react";
import dynamic from "next/dynamic";
import "../marken.css";

import { TopSectionMarken } from "../sections/TopSection";
import { AutoVerkaufenGrid } from "@/common/AutoVerkaufenGrid";
import { Banner } from "@/common/Banner";
import sellCarCash from "@/assets/auto-verkaufen/Rückbank-autoverkauf.avif";

import { fragenAlfaRomeo } from "./data";
import { HäufigeFragen } from "@/common/HäufigeFragen";
import FAQImage from "@/assets/faq-autoverkauf-autoeinfachlos.webp";
import höchstenPreis from "@/assets/auto-verkaufen/Frau-verkauft-ihr-auto.webp";
import BildTextInfo from "@/components/BildTextInfo/BildTextInfo";

// Only needed when the user reaches step 12; avoid loading auth-related JS/CSS on initial paint.
const Ratgeber = dynamic(() => import("@/components/Ratgeber/Ratgeber"), {
  ssr: false,
});

const AnmeldenSection = dynamic(() => import("@/app/anmelden/AnmeldenStepRedirect"), {
  ssr: false,
});

function AlfaRomeo() {
  const [step, setStep] = useState(1);
  // selected values
  const [selectedBrand, setSelectedBrand] = useState({ id: "", name: "" });
  const [selectedModel, setSelectedModel] = useState({ id: "", name: "" });
  const [selectedYear, setSelectedYear] = useState({ id: "", name: "" });
  const [selectedBauform, setSelectedBauform] = useState({ id: "", name: "" });
  const [selectedFuel, setSelectedFuel] = useState({ id: "", name: "" });
  const [selectedVariant, setSelectedVariant] = useState({ id: "", name: "" });
  const [selectedPs, setSelectedPs] = useState({ id: "", name: "" });
  const [selectedTransmission, setSelectedTransmission] = useState({
    id: "",
    name: "",
  });
  const [selectedDoors, setSelectedDoors] = useState({ id: "", name: "" });
  const [selectedModelType, setSelectedModelType] = useState({
    id: "",
    name: "",
  });
  const [selectedKmStand, setSelectedKmStand] = useState("");
  const isSecondaryMethod = true;

  useEffect(() => {
    if (step >= 10) {
      if (typeof AnmeldenSection?.preload === "function") {
        AnmeldenSection.preload();
      } else {
        import("@/app/anmelden/AnmeldenStepRedirect");
      }
    }
  }, [step]);


  return (
    <div className="home-container">
      <TopSectionMarken
        title="So verkaufst du dein Alfa Romeo sicher & zum besten Preis"
        linkname="Alfa Romeo"
        link="/auto-verkaufen"
        text={
          <>
            84% der Autoeinfachlos-Kunden bekommen mehr Geld.*{" "}
            <br className="desktop" />
            Hol dir deine kostenlose und sofortige Bewertung für deinen Alfa
            Romeo.
          </>
        }
        removePadding={true}
        step={step}
        setStep={setStep}
        selectedBrand={selectedBrand}
        setSelectedBrand={setSelectedBrand}
        selectedModel={selectedModel}
        setSelectedModel={setSelectedModel}
        selectedYear={selectedYear}
        setSelectedYear={setSelectedYear}
        selectedBauform={selectedBauform}
        setSelectedBauform={setSelectedBauform}
        selectedFuel={selectedFuel}
        setSelectedFuel={setSelectedFuel}
        selectedVariant={selectedVariant}
        setSelectedVariant={setSelectedVariant}
        selectedPs={selectedPs}
        setSelectedPs={setSelectedPs}
        selectedTransmission={selectedTransmission}
        setSelectedTransmission={setSelectedTransmission}
        selectedDoors={selectedDoors}
        setSelectedDoors={setSelectedDoors}
        setSelectedModelType={setSelectedModelType}
        selectedModelType={selectedModelType}
        selectedKmStand={selectedKmStand}
        setSelectedKmStand={setSelectedKmStand}
      />

      {step === 12 && (
        <>
          <AnmeldenSection
            title="Bitte gib deine E-Mail-Adresse ein, um fortzufahren"
            fin={null}
            isManual={isSecondaryMethod}
            marke={selectedBrand}
            model={selectedModel}
            baujahr={selectedYear}
            bodytype={selectedBauform}
            fueltype={selectedFuel}
            variant={selectedVariant}
            ps={selectedPs}
            gearbox={selectedTransmission}
            doors={selectedDoors}
            modelType={selectedModelType}
            kmStand={selectedKmStand}
            page="/auto-verkaufen"
          />
          <Banner removeContent className="Banner-anmelden" />
        </>
      )}

      {step !== 12 && (
        <div className="Page background-color">
          <div className="Page-wrapper">
            <AutoVerkaufenGrid
              image={sellCarCash}
              leftTitle="Warum jetzt deinen Alfa Romeo verkaufen?"
              leftText={
                <>
                  <p>
                    Ein defekter Alfa Romeo auf dem Hof kann zur Belastung
                    werden. Oft übersteigen Reparaturkosten den Restwert, und
                    potenzielle Käufer zögern wegen Motorschaden, Unfall oder
                    Getriebeschaden. Autoeinfachlos bringt dich mit über 5.000
                    seriösen Händlern in Österreich zusammen, damit du deinen
                    Alfa Romeo sicher, schnell und ohne Risiko verkaufst.
                  </p>
                  <ul className="custom-unordered-list secondary">
                    <li>
                      <strong>Wertverlust minimieren:</strong> Neuwagen
                      verlieren im ersten Jahr bis zu 25 % ihres Werts und nach
                      drei Jahren etwa die Hälfte.
                    </li>
                    <li>
                      <strong>Hohe Reparaturkosten vermeiden:</strong> Ein
                      Motorschaden oder schwerer Unfall führt häufig zum
                      wirtschaftlichen Totalschaden – die Reparatur übersteigt
                      den Marktwert. Auch nach der Reparatur bleibt der Wert
                      deutlich geringer.
                    </li>
                    <li>
                      <strong>Kapital freisetzen:</strong> Statt Geld in ein
                      altes Fahrzeug zu stecken, kannst du den Verkaufserlös in
                      ein zuverlässigeres Auto investieren.
                    </li>
                  </ul>
                  <h2>Deine Verkaufsoptionen im Vergleich</h2>
                  <h3>Privatverkauf</h3>
                  <p>
                    Höherer Preis möglich, aber zeitaufwendig. Du musst Inserate
                    schalten, Probefahrten organisieren und dich um
                    Zahlungsabwicklung kümmern.
                  </p>
                  <h3>Ankauf durch Händler</h3>
                  <p>
                    Schneller, aber oft niedrigerer Preis, weil der Händler den
                    Preis diktiert.
                  </p>
                  <h3>Autoeinfachlos</h3>
                  <p>
                    Die Vorteile beider Varianten – kostenlose Online-Bewertung,
                    mehrere Angebote von geprüften Händlern, sichere
                    Zahlungsabwicklung und Abholung an deinem Wunschort.
                  </p>
                </>
              }
              rightFirstTitle="So funktioniert der Verkauf mit Autoeinfachlos"
              rightFirstText={
                <>
                  <ul className="custom-unordered-list">
                    <li>
                      <strong>Kostenlose Online-Bewertung:</strong>{" "}
                      Trage Marke, Modell, Baujahr und Zustand deines Alfa Romeo
                      ein.
                    </li>
                    <li>
                      <strong>Angebote erhalten:</strong> Innerhalb kurzer Zeit erhältst du verbindliche
                      Ankaufangebote von Händlern in ganz Österreich.
                    </li>
                    <li>
                      <strong>Verkauf & Abholung:</strong> Du wählst das beste Angebot, der Händler holt den Wagen ab
                      und zahlt den vereinbarten Preis. Autoeinfachlos begleitet
                      dich bei allen Schritten – von der Vertragsabwicklung bis
                      zur Abmeldung.
                    </li>
                  </ul>
                </>
              }
              rightSecondTitle="Welche Faktoren beeinflussen den Verkaufspreis?"
              rightSecondText={
                <>
                  <ul className="custom-unordered-list secondary">
                    <li>Alter, Kilometerstand und Wartungshistorie</li>
                    <li>Modell, Ausstattung und Nachfrage am Markt</li>
                    <li>
                      Art und Umfang des Schadens (z. B. Motor- oder
                      Getriebeschaden)
                    </li>
                    <li>Anzahl der Vorbesitzer und genereller Pflegezustand</li>
                  </ul>
                  <p>
                    Ein gepflegter Alfa Romeo mit klar dokumentierter
                    Servicehistorie erzielt trotz Schaden einen höheren Preis als
                    ein ungepflegtes Fahrzeug.
                  </p>

                  <h2 className="AV-subheading">Praxisbeispiel</h2>

                  <p>
                    Ein Alfa Romeo mit Motorschaden würde eine Reparatur von
                    3.000 € erfordern. Der Restwert liegt aber nur bei 2.500 €.
                    In diesem Fall ist der Verkauf über Autoeinfachlos die
                    wirtschaftlichere Entscheidung – du sparst Reparaturkosten
                    und erhältst dennoch einen fairen Preis.
                  </p>
                </>
              }
            />

            <HäufigeFragen
              title="Häufig gestellte Fragen"
              fragen={fragenAlfaRomeo}
              image={FAQImage}
            />

            <Ratgeber
              title="Mehr zum Thema Alfa Romeo verkaufen"
              kaputtesAuto
              unfallAuto
              autoExport
              autoBewerten
              autoVerkaufen
              listenpreisBerechnen
            />

            <div className="Banner-sections-marken">
              <BildTextInfo
                image={höchstenPreis}
                h2
                fontSize="36px"
                title="Fazit – jetzt Alfa Romeo kostenlos bewerten"
                alt="Frau sitzt in einem Auto und nutzt ihr Smartphone, um mit Autoeinfachlos ihren Alfa Romeo zu verkaufen."
                text={
                  <>
                    <p>
                      Ein beschädigter Alfa Romeo muss nicht zur Belastung
                      werden. Mit Autoeinfachlos profitierst du von einem
                      schnellen, transparenten Verkaufsprozess, seriösen Händlern
                      und einem fairen Preis. Berechne jetzt kostenlos den Wert
                      deines Fahrzeugs und starte den Verkauf!
                    </p>
                  </>
                }
              />
            </div>
          </div>
          <Banner
            link="/auto-verkaufen"
            title="Jetzt Auto kostenlos bewerten & sicher verkaufen"
          />
        </div>
      )}
    </div>
  );
}

export default AlfaRomeo;
